import { render } from "./News21.vue?vue&type=template&id=86b83d2c&scoped=true"
import script from "./News21.vue?vue&type=script&lang=js"
export * from "./News21.vue?vue&type=script&lang=js"

import "./News21.vue?vue&type=style&index=0&id=86b83d2c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86b83d2c"]])

export default __exports__